import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faSave, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ResponseSuccessModal, ResponseFailModal } from '../../modal/Response';
import Spin from '../../Spin';
import * as api from '../../../api';

const DoorlockUninstall = ({
  isOpen,
  toggle,
  reload,
  doorlockId,
  doorlockName,
}) => {
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState(false);
  const [isOpenDoorlockUninstallSuccessModal, setIsOpenDoorlockUninstallSuccessModal] = useState(false);
  const [isOpenDoorlockUninstallFailModal, setIsOpenDoorlockUninstallFailModal] = useState(false);
  const [ messageDoorlockUninstallFail, setMessageDoorlockUninstallFail ] = useState('');

  const uninstallDoorlock = async () => {
    try {
      setIsLoading(true);
      await api.uninstallDoorlock({doorlockId});
      toggle();
      setIsOpenDoorlockUninstallSuccessModal(true);
      setTimeout(() => {
        setIsOpenDoorlockUninstallSuccessModal(false);
        reload();
      }, 1500);
    } catch (error) {
      toggle();
      if (!error.response) setMessageDoorlockUninstallFail(error.message);
      else setMessageDoorlockUninstallFail(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenDoorlockUninstallFailModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        size='sm'
      >
        <Spin isSpin={isLoading} isModal={true}/>
        <ModalBody className='text-center m-3'>
          <FontAwesomeIcon icon={faQuestionCircle} style={{fontSize:'5em', color:'orange'}}/>
          <p className='mb-0 mt-4' style={{fontSize:'16px'}}>
            {t('confirm_message.uninstall_doorlock')}
            <span className='ml-5'>
              [<span style={{fontWeight:'bold', color:'rgb(59, 125, 221)'}}>{doorlockName || '-'}</span>]
            </span>
          </p>
          <button className='modal-btn-cancel' onClick={() => toggle()}>
            <FontAwesomeIcon icon={faTimesCircle} style={{paddingRight:'3px'}}/>{t('button.cancel')}
          </button>
          <button className='modal-btn-confirm' onClick={uninstallDoorlock}>
            <FontAwesomeIcon icon={faSave} style={{paddingRight:'3px'}}/>{t('button.ok')}
          </button>
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenDoorlockUninstallSuccessModal}
        toggle={() => setIsOpenDoorlockUninstallSuccessModal(!isOpenDoorlockUninstallSuccessModal)}
        message={t('success_message.uninstall_doorlock')}
      />
      <ResponseFailModal
        isOpen={isOpenDoorlockUninstallFailModal}
        toggle={() => setIsOpenDoorlockUninstallFailModal(!isOpenDoorlockUninstallFailModal)}
        message={messageDoorlockUninstallFail || t('error_message.uninstall_doorlock')}
      />
    </Fragment>
  );
}

export default DoorlockUninstall;